<template>
    <div>
        <el-alert
            v-if='warningText'
            style='margin-top: .5rem;margin-bottom: .5rem;'
            :title='warningText'
            :type='warningType'
            :closable='false'>
        </el-alert>
        <el-table :data='dynamicTableFormList'
                  style='width: 100%'>
            <el-table-column width='150px' :label='keyName'>
                <template slot-scope='scope'>
                    <el-input size='mini' @blur='handleValueChange' v-model='scope.row.key' :placeholder='`请输入${keyName}`' />
                </template>
            </el-table-column>
            <el-table-column :label='valueName'>
                <template slot-scope='scope'>
                    <el-input type='textarea' :autosize='{ minRows: 1, maxRows: 2 }' rows='2'
                              size='mini' @blur='handleValueChange' v-model='scope.row.value' :placeholder='`请输入${valueName}`' />
                </template>
            </el-table-column>
            <el-table-column
                label='操作'
                width='160px'>
                <template slot-scope='scope' slot='header'>
                    <template>
                        <slot name='table-header'></slot>
                    </template>
                    <el-button type='text' @click='addEmptyDynamicForm' size='mini' >增加一项</el-button>
                    <el-button v-if='showJsonParseButton' type='text' @click='addJsonParse' size='mini' >Json解析</el-button>
                </template>
                <template slot-scope='scope'>
                    <el-button
                        @click.native.prevent='removeDynamicForm(scope.$index)'
                        type='text'
                        size='small'>
                        移除
                    </el-button>
                    <slot :data='dynamicTableFormList' :rowIndex='scope.$index' name='table-operation'></slot>
                </template>
            </el-table-column>
        </el-table>
        
        <el-dialog title='Json解析' :before-close='cancel' :visible.sync='open' append-to-body width='40%'>
            <el-alert
                style='margin-top: .5rem;margin-bottom: .5rem;'
                title='点击解析之后，如果原来存在数据，则会进行数据合并'
                type='success'
                :closable='false'>
            </el-alert>
            <el-input v-model='inputJsonContent' type='textarea' :autosize="{ minRows: 25, maxRows: 50}"/>
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='handleParse'>解 析</el-button>
                <el-button @click='cancel'>取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { judgeJson, judgeObject, mergeMultiObject } from '@/utils/object';

export default defineComponent({
    name: 'DynamicForm',
    data() {
        return {
            dynamicTableFormList: [],
            generateObject: {},
            generateJsonContent: undefined,
            generateSortedJsonContent: undefined,
            watchStatus: false,
            inputJsonContent: '',
            open: false
        }
    },
    props: {
        jsonContent: {
            type: String
        },
        warningText: String,
        warningType: String,
        keyName: {
            type: String,
            default: function() {
                return "Key"
            }
        },
        valueName: {
            type: String,
            default: function() {
                return "Value"
            }
        },
        showJsonParseButton: true,
        generateSortJson: {
            type: Boolean,
            default: function() {
                return false
            }
        }
    },
    emits: ['getDynamicJsonObject', 'getDynamicJsonString'],
    methods: {
        cancel() {
            this.open = false
        },
        addEmptyDynamicForm() {
            this.dynamicTableFormList.push({
                key: '',
                value: '',
                createTime: new Date().getTime()
            });
        },
        addJsonParse() {
            this.open = true
        },
        async handleParse() {
            if (!this.inputJsonContent) {
                message.warning("请输入json内容")
            }
            await this.convertDynamicForm()
            // 将输入的json转换为对象
            let inputObject;
            try {
                inputObject = JSON.parse(this.inputJsonContent);
            } catch (e) {
                message.warning("json内容格式错误")
                return
            }
            let mergedObj = await mergeMultiObject(this.generateObject, inputObject)
            this.dynamicTableFormList = []
            this.generateObject = {}
            await this.handleConvert(JSON.stringify(mergedObj, null, 2))
            await this.handleValueChange()
            this.open = false
            message.success("解析成功")
        },
        removeDynamicForm(index) {
            this.dynamicTableFormList.splice(index, 1);
            this.handleValueChange()
        },
        handleObjectToTableList() {
            this.dynamicTableFormList = []
            this.generateObject = {}
            if (!this.jsonContent) {
                return
            }
            // let obj = JSON.parse(this.jsonObject[this.jsonKey])
            this.handleConvert(this.jsonContent)
        },
        async handleConvert(jsonStr) {
            let jsonObject = JSON.parse(jsonStr)
            for (let key in jsonObject) {
                if (judgeObject(jsonObject[key])) {
                    this.dynamicTableFormList.push({
                        key: key,
                        value: JSON.stringify(jsonObject[key], null, 2)
                    });
                }else {
                    this.dynamicTableFormList.push({
                        key: key,
                        value: jsonObject[key]
                    });
                }
            }
        },
        async buildJsonContent() {
            let json = "{"
            for (let i = 0; i < this.dynamicTableFormList.length; i++) {
                let data = {}
                let singleObj = this.dynamicTableFormList[i]
                let key = singleObj['key']
                data[key] = singleObj['value']
                let singleJson = JSON.stringify(data)
                singleJson = singleJson.substring(1, singleJson.length - 1)
                json = json + singleJson + ","
                if (i === this.dynamicTableFormList.length - 1) {
                    json = json.substring(0, json.length - 1) + "}"
                    this.generateSortedJsonContent = json
                }
            }
        },
        async convertDynamicForm() {
            let keySet = new Set();
            this.dynamicTableFormList.map(copy => {
                return copy.key;
            }).forEach(key => {
                keySet.add(key);
            });
            if (keySet.size < this.dynamicTableFormList.length) {
                message.warning('表单中存在重复key');
                throw "表单中存在重复key"
            }
            await this.buildJsonContent()
            // 将数组转换为json
            for (let i = 0; i < this.dynamicTableFormList.length; i++) {
                let key = this.dynamicTableFormList[i]['key'];
                let value = this.dynamicTableFormList[i]['value'];
                if (judgeJson(value)) {
                    this.generateObject[key] = JSON.parse(value);
                }else {
                    this.generateObject[key] = value;
                }
            }
        },
        async handleValueChange() {
            try {
                await this.convertDynamicForm()
                if (this.generateSortJson) {
                    this.$emit("getDynamicJsonString", this.generateSortedJsonContent)
                }else {
                    this.$emit("getDynamicJsonString", JSON.stringify(this.generateObject))
                }
                this.$emit("getDynamicJsonObject", this.generateObject)
            }catch (e) {}
        }
    },
    mounted() {
        if (!this.watchStatus && this.jsonContent) {
            this.handleObjectToTableList()
        }
    },
    watch: {
        jsonContent: {
            deep: true,
            handler: function() {
                this.watchStatus = true
                this.handleObjectToTableList()
            }
        },
        dynamicTableFormList: {
            deep: true,
            handler: function() {
                this.handleValueChange()
            }
        }
    }
});
</script>